module.exports = __webpack_public_path__ + "img/e3_img1.0332319.webp";